Link = require('react-router-dom').Link
common = require('./common')
HeaderBar = require('./header_bar')
# ProjectHeaderCKEditor = require('./project_header_ckeditor')
ProjectHeader = require('./project_header')

module.exports = class UserOwnedProjectData extends React.Component
  displayName: 'UserOwnedProjectData'

  constructor: (props) ->
      super(props)
      projectid = @props.match.params.projectId
      @state = {
          data: { projectid:projectid, project: { } }
      }

  componentDidMount: =>
      common.projectData((data) =>
          @setState({data: { project: data.project } })
          document.title = data.project.title
      , @state.data.projectid)

  render: =>
      p=@state.data.project
      <div>
          <HeaderBar />
          <ProjectHeader key={Math.random()}
                         project={@state.data.project}
                         userid={@state.userid}
                         roles={@state.roles} />
          <div className='proj_listing'>
              Project data listed with relevant fields
          </div>
      </div>
